import React from 'react'
import CSS from './RisingText.module.css'

function RisingText() {
    return (
        <div className={CSS.container}>
            <div className={CSS.layer}>MY PROJECTS COMING SOON</div>
            <div className={CSS.layer}>MY PROJECTS COMING SOON</div>
            <div className={CSS.layer}>MY PROJECTS COMING SOON</div>
            <div className={CSS.layer}>MY PROJECTS COMING SOON</div>
            <div className={CSS.layer}>MY PROJECTS COMING SOON</div>
        </div>
    )
}

export default RisingText
